import React from 'react';
import { Button } from '../../../ui/Button';
import { HeartFilledIcon, HeartOutlineIcon } from '../../../ui/icons';

export type SocialActionButtonProps = {
  onClick: () => void;
  'aria-label': string;
  disabled?: boolean;
  isSaved?: boolean;
  size?: 'sm' | 'md' | 'lg';
};

export const FavoriteButton = React.forwardRef<HTMLButtonElement, SocialActionButtonProps>(function FavoriteButton(
  { onClick, 'aria-label': ariaLabel, disabled = false, isSaved = false, size = 'md' },
  ref,
) {
  return (
    <Button
      ref={ref}
      shape="circle"
      tone="brand"
      emphasis="filled"
      size={size}
      onClick={onClick}
      aria-label={ariaLabel}
      title={ariaLabel}
      disabled={disabled}
    >
      {isSaved ? <HeartFilledIcon /> : <HeartOutlineIcon />}
    </Button>
  );
});
